import React, { useState, useEffect } from "react";
import Footer from "../Footer/footer";
import Header from "../Header/header";
import axios from "axios";
import { imageUrl, websiteUrl } from "../../const/constants";
import { getOurBooks } from "./_request";
import { useNavigate } from "react-router-dom";

const OurBooks = () => {
  const [aboutIntro, setAboutIntro] = useState(null);
  const [aboutLoading, setAboutLoading] = useState(true);
  const [books, setBooks] = useState([]);
  const BOOK_URL = `${imageUrl}/matbuaatImages`;
  const navigate = useNavigate();
  const getBooksList = async () => {
    setAboutLoading(true);
    try {
      const response = await getOurBooks();
      if (response.Result) {
        setBooks(response.Books);
        setAboutLoading(false);
      }
    } catch (error) {
    } finally {
      setAboutLoading(false);
    }
  };
  useEffect(() => {
    setAboutLoading(true);
    axios
      .get(`${websiteUrl}/api/about?section_key=ourbooks_intro&active=1`)
      .then((res) => {
        if (res.data.success && res.data.data && res.data.data.length > 0) {
          setAboutIntro(res.data.data[0]);
        } else {
          setAboutIntro(null);
        }
        setAboutLoading(false);
      })
      .catch(() => {
        setAboutIntro(null);
        setAboutLoading(false);
      });
    getBooksList();
  }, []);

  const handleBookClick = (id) => {
    navigate(`/tableeghat/mutabaat/${id}`);
  };

  return (
    <>
      <Header />
      <div className="bg-white min-h-screen w-full mt-5 px-5 sm:px-10 md:px-10 lg:px-20 text-black text-center font-nastaleeqRegular font-normal">
        <div className="pt-10 sm:pt-16">
          {/* Dynamic About Intro */}
          {aboutLoading ? (
            <div className="flex justify-center items-center h-24">
              <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
            </div>
          ) : aboutIntro ? (
            <div className="bg-primaryBG rounded-3xl py-8 sm:py-10 md:py-12 px-5 sm:px-10 md:px-10 lg:px-20">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-nastaleeqKasheeda">
                {aboutIntro.section_title}
              </h1>
              <p className="mt-4 text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqRegular lg:px-20">
                {aboutIntro.section_content}
              </p>
              {aboutIntro.image && (
                <img
                  src={`${websiteUrl}/aboutImage/${aboutIntro.image}`}
                  alt="about"
                  className="mx-auto max-w-xs md:max-w-sm lg:max-w-md w-full h-auto mt-4"
                />
              )}
            </div>
          ) : (
            <div className="text-center text-gray-500 py-8">
              کوئی تعارف دستیاب نہیں
            </div>
          )}
          {/*
                    <div className="bg-primaryBG rounded-3xl py-8 sm:py-10 md:py-12 px-5 sm:px-10 md:px-10 lg:px-20">
                        <h1 className='text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-nastaleeqKasheeda'>کتابوں سے آشنائی</h1>
                        <p className='mt-4 text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqRegular lg:px-20'>انجمن مشتاقان نور کتابوں سے تعلیمات اہل بیت کے سیکھنے اور پڑھنے کے ماحول کی حوصلہ افزائی اور فروغ دیتی ہے۔ اس سلسلے میں ہم نے ماہر مصنفین، علمائے کرام اور کتب کے ماہرین کی لکھی ہوئی چند کتابیں شائع کی ہیں تاکہ معصومین کا علم اردو میں پڑھنے کی خالص صورت میں فراہم کیا جا سکے۔</p>
                    </div>
                    */}

          {/* Books Grid */}
          <div
            dir="rtl"
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-12 px-10 lg:px-20 mb-20"
          >
            {books.length > 0 ? (
              books.map((book, index) => (
                <div
                  onClick={() => handleBookClick(book.id)}
                  key={index}
                  className="flex flex-col items-center transition-all duration-300 hover:scale-105 cursor-pointer"
                >
                  {/* Book Image */}
                  <img
                    src={`${BOOK_URL}/${book.image}`}
                    alt={book.name}
                    className="w-52 h-auto rounded-lg transition-all duration-300 hover:scale-[1.02]"
                    loading="lazy"
                  />
                  {/* Book Name */}
                  <p className="mt-4  text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda text-black hover:text-primary transition-all duration-300">
                    {book.bookName}
                  </p>
                  {/* Author Name */}
                  <p className="mt-2  text-md sm:text-lg md:text-lg lg:text-xl font-nastaleeqRegular text-gray-500 transition-all duration-300 hover:text-primary/80">
                    {book.writerName}
                  </p>
                </div>
              ))
            ) : (
              <div className="text-center text-gray-500 py-8">
                کوئی تعارف دستیاب نہیں
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OurBooks;
